import React, { Component } from 'react';
import Table9_8_1 from "./9-8-1";
import Table9_8_2 from "./9-8-2";
import Table9_8_3 from "./9-8-3";
import Table9_8_4 from "./9-8-4";

export class index extends Component {
  render() {
    return (
      <div>
        <Table9_8_1 {...this.props} />
        <Table9_8_2 {...this.props} />
        <Table9_8_3 {...this.props} />
        <Table9_8_4 {...this.props} />
      </div>
    )
  }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/index.js